var _path, _path2, _rect, _path3, _mask, _g, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 118,
    viewBox: "0 0 140 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 70H63.6364C63.6364 72.9288 61.2621 75.303 58.3333 75.303H5.30303C2.37425 75.303 0 72.9288 0 70Z",
    fill: "#DEE0ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1816 70H82.7271V117.727H73.1816V70Z",
    fill: "url(#paint0_linear)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73.1816,
    y: 70,
    width: 9.54546,
    height: 9.54546,
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 31.6667C23.333 20.621 32.2873 11.6667 43.333 11.6667H78.4845V70.0001H23.333V31.6667Z",
    fill: "#C7CADD"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 11,
    width: 56,
    height: 59
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.333 31.6667C23.333 20.621 32.2873 11.6667 43.333 11.6667H78.4845V70.0001H23.333V31.6667Z",
    fill: "#C7CADD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4395 70.0001L71.591 70.0001V11.6667H36.4395C35.5928 11.6667 34.7584 11.7194 33.9395 11.8215C43.8052 13.0517 51.4395 21.4677 51.4395 31.6667V70.0001Z",
    fill: "#ABAEC9"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6367 70.0001H124.091V31.6667C124.091 20.6211 115.137 11.6667 104.091 11.6667H43.6367C54.6824 11.6667 63.6367 20.6211 63.6367 31.6667V70.0001Z",
    fill: "#DEE0ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1816 4.65249C73.1816 2.66872 74.7898 1.06055 76.7736 1.06055C78.8488 1.06055 80.4922 2.81397 80.358 4.88482L77.4353 49.9783C77.3627 51.0983 76.4331 51.9696 75.3107 51.9696C74.1348 51.9696 73.1816 51.0164 73.1816 49.8406V4.65249Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5594 55.7481C94.9455 55.3072 93.9845 53.6522 94.4015 52.032L100.257 53.6009C100.156 53.9932 99.9775 54.3614 99.7329 54.6843C99.1126 55.4624 98.156 55.895 97.1621 55.8468L97.1548 55.8449L97.1357 55.8398L97.1211 55.8358L97.105 55.8315L97.0948 55.8288C96.9142 55.8184 96.735 55.7914 96.5594 55.7481ZM109.447 54.4944L86.0253 48.2187L86.8098 45.291L90.1297 44.6116L92.287 36.5604C92.7633 34.4744 93.7789 32.55 95.2321 30.9796C96.6454 29.5407 98.6071 28.7757 100.621 28.8779L101.476 25.6867L107.332 27.2556L106.477 30.4468C110.011 32.3572 111.211 36.1994 109.853 41.2673L107.696 49.3184L110.231 51.5667L109.447 54.4944Z",
    fill: "#7A7FA7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 17.9395,
    y: -4.33325,
    width: 69.6515,
    height: 90.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 77.9544,
    y1: 95.4545,
    x2: 77.9544,
    y2: 117.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0ED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 76.3635,
    y1: 79.5455,
    x2: 76.3635,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7CADD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABAEC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 76.8938,
    y1: 1.06055,
    x2: 76.8938,
    y2: 51.9696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7CADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABAEC9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/no-notification.e926c054.svg";
export { ForwardRef as ReactComponent };